import { useMe } from "../../context/MeContext";
import { useCompanies } from "../../hooks/useCompanies";
import useExperienceService from "../../services/ExperienceService";
import LoadingEllipsis from "../LoadingEllipsis";
import CompanyAnalyticsByExperienceBlock from "./CompanyAnalyticsByExperienceBlock";

export default function AnalyticsHome() {
  const { me } = useMe();

  const { companies, isLoading: isLoadingCompanies } = useCompanies();

  const { getExperiencesForCompany } = useExperienceService();

  // if loading companies, show loading spinner
  if (isLoadingCompanies) {
    return (
      <section>
        <LoadingEllipsis />
      </section>
    );
  }

  return (
    <section>
      <p>
        A snapshot of your latest experience analytics. Click in to show more
      </p>
      <div>
        {companies.map((company) => (
          <CompanyAnalyticsByExperienceBlock company={company} key={company.id} />
        ))}
      </div>
    </section>
  );
}
